import React, {createContext, useContext, useEffect, useState} from "react";
import Editable from "../ui/editable";

const FilterContext = createContext(null);

export const useFilterContext = () => useContext(FilterContext);

function applyFilter(data, filter) {
    return data.filter(datum => {
        return Object.keys(filter).reduce((match, filterKey) => {
            return match &&
                typeof datum[filterKey] !== "undefined" &&
                (datum[filterKey] ?? "").toString().indexOf(filter[filterKey].toString()) !== -1;
        }, true);
    });
}

export const FilterableContainer = ({initialData, children}) => {
    const [data, setData] = useState(initialData ?? null);
    const [filter, setFilter] = useState({ });

    useEffect(
        () => {
            const newData = applyFilter(initialData, filter);
            setData(newData);
        },
        [filter, initialData]
    )

    function mergeFilter(additionalFilter) {
        setFilter({
            ...filter,
            ...additionalFilter
        });
    }

    const isFiltered = Object.values(filter).reduce((a, b) => a || b !== undefined, false);

    return <FilterContext.Provider value={{filter, isFiltered, mergeFilter, setFilter, data, setData: newData => setData(applyFilter(newData, filter))}}>
        {children}
    </FilterContext.Provider>;
}

export function FilterInput({column}) {
    const { mergeFilter, filter } = useFilterContext();
    return <Editable onChange={(newValue) => mergeFilter({ [column]: newValue })} value={filter[column] ?? ""} />
}
